import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios'; // Zmieniono na bezpośredni import z biblioteki
import ButtonRegular from './ui/ButtonRegular';
import '../styles/PagePaymentStatus.css';

function PagePaymentStatus() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    // 1. Wyciągamy oba możliwe parametry z URL
    const orderNumber = searchParams.get('p24_order_id') || searchParams.get('orderNumber');
    const formNumber = searchParams.get('formNumber');

    // Identyfikator, który wyświetlimy użytkownikowi na ekranie
    const displayId = orderNumber || formNumber;

    const [status, setStatus] = useState('loading');
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!orderNumber && !formNumber) {
            setStatus('error');
            setError('Brak numeru identyfikacyjnego płatności w adresie URL.');
            return;
        }

        const verifyPayment = async () => {
            try {
                let response;
                
                // Używamy pełnego adresu URL na podstawie Twojej zmiennej środowiskowej
                const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';
                
                // 2. Ścieżka dla ZWYKŁEGO ZAMÓWIENIA (Wymaga zalogowania)
                if (orderNumber) {
                    const token = localStorage.getItem('authToken');
                    response = await axios.get(
                        `${apiUrl}/api/orders/verify/${orderNumber}`,
                        {
                            headers: {
                                Authorization: `Bearer ${token}`,
                            },
                        }
                    );
                } 
                // 3. Ścieżka dla FORMULARZA PUBLICZNEGO (Brak wymogu logowania)
                else if (formNumber) {
                    response = await axios.get(
                        `${apiUrl}/api/payment/forms/verify/${formNumber}`
                    );
                }

                const data = response.data;

                // Sprawdzamy status zwrócony przez backend
                if (data && data.paymentStatus === 'paid') {
                    setStatus('success');
                } else {
                    setStatus('pending');
                }

            } catch (err) {
                console.error('Błąd weryfikacji płatności:', err);
                if (err.response) {
                    if (err.response.status === 403) {
                        setError('To zamówienie nie należy do Twojego konta.');
                    } else if (err.response.status === 404) {
                        setError('Nie znaleziono takiego zamówienia w naszym systemie.');
                    } else {
                        setError('Wystąpił nieoczekiwany błąd serwera.');
                    }
                } else {
                    setError('Błąd połączenia z serwerem. Sprawdź swoje połączenie internetowe.');
                }
                setStatus('error');
            }
        };

        verifyPayment();
    }, [orderNumber, formNumber]);

    return (
        <div className="home payment-page">
            <div className="overlay">
                <div className="payment-success-container">
                    <div className="payment-card">
                        {/* 1. STATUS: ŁADOWANIE */}
                        {status === 'loading' && (
                            <div className="payment-status-info">
                                <h2 className="status-title loading">⏳ Weryfikacja...</h2>
                                <p>Prosimy o cierpliwość, sprawdzamy status Twojej wpłaty.</p>
                            </div>
                        )}
                        {/* 2. STATUS: SUKCES (OPŁACONO) */}
                        {status === 'success' && (
                            <div className="payment-status-info">
                                <h2 className="status-title success">✅ Płatność potwierdzona</h2>
                                <p>Dziękujemy za zakupy! Twoje zamówienie jest już w realizacji.</p>
                                <div className="order-details">
                                    <p>{orderNumber ? 'Numer zamówienia' : 'Numer formularza'}: <strong>{displayId}</strong></p>
                                </div>
                            </div>
                        )}

                        {/* 3. STATUS: OCZEKIWANIE LUB BŁĄD */}
                        {(status === 'pending' || status === 'error') && (
                            <div className="payment-status-info">
                                <h2 className="status-title pending">🕒 Status płatności</h2>
                                <div className="custom-error-message">
                                    <p>Nie otrzymaliśmy jeszcze potwierdzenia o Twojej płatności.</p>
                                    <p>
                                        Księgowanie przez Przelewy24 może potrwać do kilku minut. Jeśli status nie zmieni się za chwilę, skontaktuj się z nami:  
                                        <a href="mailto:kontakt@kwiatyzgor.pl" className="status-email-link"> kontakt@kwiatyzgor.pl </a>.
                                    </p>
                                    {orderNumber && (
                                        <p>
                                            Jeśli chcesz spróbować ponownie opłacić swoje zamówienie, możesz to zrobić w swoim profilu 
                                            w zakładce <strong>"Moje zamówienia"</strong>.
                                        </p>
                                    )}
                                </div>

                                {error && <p className="technical-error-hint">({error})</p>}

                                <div className="order-details">
                                    <p>{orderNumber ? 'Numer zamówienia' : 'Numer formularza'}: <strong>{displayId}</strong></p>
                                </div>
                            </div>
                        )}

                        <div className="payment-success-actions">
                            <ButtonRegular onClick={() => navigate('/')}>
                                Wróć do strony głównej
                            </ButtonRegular>
                            
                            {/* Ukrywamy przycisk "Moje zamówienia" jeśli to był formularz publiczny bez logowania */}
                            {orderNumber && (
                                <ButtonRegular onClick={() => navigate("/profile", { state: { tab: "orders" } })}>
                                    Moje zamówienia
                                </ButtonRegular>
                            )}
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PagePaymentStatus;